import { createContext, useContext } from 'react'
import { SessionContextValue } from 'features/session-manager/SessionProvider.types'

export const SessionContext = createContext<SessionContextValue | undefined>(undefined)

export function useSessionContext() {
  return useContext(SessionContext)!
}
